import { render, staticRenderFns } from "./menzhenjiaofeijilu.vue?vue&type=template&id=2275f7c2&scoped=true&"
import script from "./menzhenjiaofeijilu.vue?vue&type=script&lang=js&"
export * from "./menzhenjiaofeijilu.vue?vue&type=script&lang=js&"
import style0 from "./menzhenjiaofeijilu.vue?vue&type=style&index=0&id=2275f7c2&rel=stylesheet%2Fless&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2275f7c2",
  null
  
)

export default component.exports